/* feelingirl — gaveta do carrinho (replica da cart-drawer do Prestige 10 dele, sections/cl-cart-drawer).
   Abre no icone do carrinho e ao adicionar produto: intercepta TODO form de /cart/add na fase de
   captura (antes do product-form do Shrine), posta por /cart/add.js e redesenha por /cart.js.
   Frete gratis (frase + barra), itens com - / + e Remove, linha do Mystery Box (escolhe o tamanho
   e SELECT adiciona), "Customers Also Bought" (cards, setas, toque e arraste; tira o que ja esta no
   carrinho, cada card leva ao produto), subtotal e economia (compare_at - preco). */
(function () {
  'use strict';
  var D, O, money = 'R$ {{amount_with_comma_separator}}', cart = null, ups = [], CMP = {}, asked = {}, applied = '';
  function fmt(c) {
    var n = (c || 0) / 100, a = n.toFixed(2);
    return money
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, a.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(n)))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(n)))
      .replace(/\{\{\s*amount\s*\}\}/, a.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  var MINUS = '<svg viewBox="0 0 10 2" width="10" height="2" aria-hidden="true"><path d="M0 1h10" stroke="currentColor" stroke-width="1.2"/></svg>';
  var PLUS = '<svg viewBox="0 0 10 10" width="10" height="10" aria-hidden="true"><path d="M0 5h10M5 0v10" stroke="currentColor" stroke-width="1.2"/></svg>';

  function bubble(count) {
    document.querySelectorAll('#cart-icon-bubble, a[href$="/cart"].header__icon, .header__icon--cart').forEach(function (b) {
      var c = b.querySelector('.cart-count-bubble');
      if (!count) { if (c) c.remove(); return; }
      if (!c) { c = document.createElement('div'); c.className = 'cart-count-bubble'; b.appendChild(c); }
      c.innerHTML = '<span aria-hidden="true">' + count + '</span><span class="visually-hidden">' + count + ' items</span>';
    });
  }
  function free(total) {
    var t = +D.getAttribute('data-free') || 0, msg = D.querySelector('[data-cl-free-msg]'), fill = D.querySelector('[data-cl-free-fill]');
    if (!msg) return;
    if (!t) { msg.hidden = true; return; }
    var miss = Math.max(0, t - total);
    msg.innerHTML = miss ? esc(D.getAttribute('data-free-text')).replace('[amount]', '<strong>' + esc(fmt(miss)) + '</strong>') : esc(D.getAttribute('data-free-done'));
    if (fill) fill.style.width = Math.min(100, total / t * 100) + '%';
  }
  function upsell(items) {
    var host = D.querySelector('[data-cl-upsell]'), track = D.querySelector('[data-cl-up-track]');
    if (!host || !track) return;
    var inCart = {}; items.forEach(function (it) { inCart[it.product_id] = 1; });
    var list = ups.filter(function (p) { return p && !inCart[p.id]; }).slice(0, 12);
    host.hidden = !list.length;
    track.innerHTML = list.map(function (p) {
      var v0 = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      var cmp = p.compare && p.compare > v0.price ? '<s>' + fmt(p.compare) + '</s>' : '';
      return '<a class="clcd__up" href="' + esc(p.url) + '">' +
        '<span class="clcd__up-media"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' +
        (p.badge ? '<span class="clcd__up-badge">' + esc(p.badge) + '</span>' : '') +
        (p.level ? '<span class="clcd__up-level"><img src="' + esc(p.level[0]) + '" alt="">' + esc(p.level[1]) + '</span>' : '') + '</span>' +
        (p.series ? '<span class="clcd__up-series">' + esc(p.series) + '</span>' : '') +
        '<span class="clcd__up-title">' + esc(p.title) + '</span>' +
        '<span class="clcd__up-price"><b>' + fmt(v0.price) + '</b>' + cmp + '</span></a>';
    }).join('');
    arrows();
  }
  function arrows() {
    var tr = D.querySelector('[data-cl-up-track]'); if (!tr) return;
    var p = D.querySelector('[data-cl-up="-1"]'), n = D.querySelector('[data-cl-up="1"]');
    if (p) p.disabled = tr.scrollLeft <= 2;
    if (n) n.disabled = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 2;
  }
  function render(c) {
    if (!D || !c) return;
    cart = c;
    var items = c.items || [], gid = +D.getAttribute('data-gift'), save = 0;
    D.classList.toggle('is-empty', !c.item_count);
    D.querySelectorAll('[data-cl-cart-count]').forEach(function (e) { e.textContent = c.item_count; });
    D.querySelector('[data-cl-cart-items]').innerHTML = items.map(function (it, i) {
      var opts = (it.options_with_values || []).filter(function (o) { return o.name !== 'Title' && o.value !== 'Default Title'; })
        .map(function (o) { return '<li>' + esc(o.name) + ' <span>' + esc(o.value) + '</span></li>'; }).join('');
      var props = it.properties ? Object.keys(it.properties).filter(function (k) { return k.charAt(0) !== '_' && it.properties[k]; })
        .map(function (k) { return '<li>' + esc(k) + ' <span>' + esc(it.properties[k]) + '</span></li>'; }).join('') : '';
      var unitCmp = Math.max(it.original_price || 0, CMP[it.variant_id] || 0);
      var lineCmp = unitCmp * it.quantity;
      if (lineCmp > it.final_line_price) save += lineCmp - it.final_line_price;
      var price = (lineCmp > it.final_line_price ? '<s>' + fmt(lineCmp) + '</s>' : '') + '<b>' + fmt(it.final_line_price) + '</b>';
      return '<div class="clcd__item" data-line="' + (i + 1) + '">' +
        '<a class="clcd__img" href="' + esc(it.url) + '" tabindex="-1"><img src="' + esc(img(it.image, 300)) + '" alt="' + esc(it.product_title) + '" loading="lazy"></a>' +
        '<div class="clcd__info"><a class="clcd__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        '<div class="clcd__opts"><ul>' + opts + props + '</ul><button type="button" class="clcd__remove" data-q="0">Remove</button></div>' +
        '<div class="clcd__row"><div class="clcd__qty">' +
        '<button type="button" data-q="' + (it.quantity - 1) + '" aria-label="Decrease quantity">' + MINUS + '</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-q="' + (it.quantity + 1) + '" aria-label="Increase quantity">' + PLUS + '</button></div>' +
        '<p class="clcd__price">' + price + '</p></div></div></div>';
    }).join('');
    D.querySelectorAll('[data-cl-cart-total]').forEach(function (e) { e.textContent = fmt(c.total_price); });
    save += c.total_discount || 0;
    var sv = D.querySelector('[data-cl-save]'), sr = D.querySelector('[data-cl-save-row]');
    if (sv) sv.textContent = fmt(save);
    if (sr) sr.hidden = !save;
    var gr = D.querySelector('[data-cl-gift-row]');
    if (gr) gr.hidden = !c.item_count || items.some(function (it) { return it.product_id === gid; });
    /* codigos dos kits (replica do Kaching): aplicados no carrinho e no link do checkout */
    var codes = []; items.forEach(function (it) { var k = it.properties && it.properties._cl_code; if (k && codes.indexOf(k) < 0) codes.push(k); });
    var ck = D.querySelector('[data-cl-checkout]');
    if (ck) ck.setAttribute('href', '/checkout' + (codes.length ? '?discount=' + encodeURIComponent(codes.join(',')) : ''));
    var key = codes.slice().sort().join(',');
    if (key && key !== applied) {
      applied = key;
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: codes.join(',') }) })
        .then(function (r) { return r.ok ? r.json() : null; }).then(function (c2) { if (c2 && c2.items) render(c2); }).catch(function () {});
    }
    free(c.total_price);
    upsell(items);
    /* /cart.js nao traz compare_at: busca o .js do produto uma vez e redesenha */
    var need = items.filter(function (it) { return !(it.variant_id in CMP) && !asked[it.handle]; });
    if (need.length) Promise.all(need.map(function (it) {
      asked[it.handle] = 1;
      return fetch('/products/' + it.handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
        .then(function (p) { (p.variants || []).forEach(function (v) { CMP[v.id] = v.compare_at_price || 0; }); }).catch(function () {});
    })).then(function () { if (cart === c) render(c); });
    bubble(c.item_count);
  }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }); }
  var seq = 0;
  function refresh() { var my = ++seq; return getCart().then(function (c) { if (my === seq) render(c); return c; }); }
  function open() {
    if (!D) return;
    D.classList.add('is-open'); O.classList.add('is-open'); D.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('clcd-lock');
    setTimeout(function () { D.focus(); arrows(); }, 50);
  }
  function close() {
    if (!D) return;
    D.classList.remove('is-open'); O.classList.remove('is-open'); D.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('clcd-lock');
  }
  function change(line, q) {
    D.classList.add('is-busy');
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: Math.max(0, q) }) })
      .then(function (r) { return r.json(); }).then(render).catch(refresh).then(function () { D.classList.remove('is-busy'); });
  }
  function add(body, isForm) {
    return fetch('/cart/add.js', { method: 'POST', headers: isForm ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function upStep(dir) {
    var tr = D.querySelector('[data-cl-up-track]'); if (!tr) return;
    var c = tr.firstElementChild, w = c ? c.getBoundingClientRect().width + 10 : tr.clientWidth * 0.8;
    tr.scrollBy({ left: dir * w, behavior: 'smooth' });
  }
  function dragTrack() {
    var tr = D.querySelector('[data-cl-up-track]'); if (!tr) return;
    tr.addEventListener('scroll', function () { arrows(); }, { passive: true });
    var down = false, sx = 0, sl = 0, moved = false;
    tr.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = tr.scrollLeft; tr.style.scrollSnapType = 'none'; });
    window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 5) moved = true; tr.scrollLeft = sl - dx; });
    window.addEventListener('pointerup', function () { if (!down) return; down = false; setTimeout(function () { tr.style.scrollSnapType = ''; }, 350); });
    tr.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    tr.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }
  function init() {
    D = document.getElementById('ClCartDrawer'); O = document.getElementById('ClCartOverlay');
    if (!D) return;
    money = D.getAttribute('data-money') || money;
    try { ups = JSON.parse(D.querySelector('[data-cl-upsell-json]').textContent) || []; } catch (e) { ups = []; }
    window.ClCart = { open: function () { refresh().then(open, open); }, close: close, refresh: refresh };
    dragTrack();
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-cl-cart-close]')) { close(); return; }
      var ic = t.closest('#cart-icon-bubble, a[href$="/cart"], a[href="/cart"]');
      if (ic && !t.closest('#ClCartDrawer')) { e.preventDefault(); e.stopPropagation(); refresh().then(open, open); return; }
      var q = t.closest('#ClCartDrawer [data-q]');
      if (q) { var it = q.closest('[data-line]'); change(+it.getAttribute('data-line'), +q.getAttribute('data-q')); return; }
      var u = t.closest('#ClCartDrawer [data-cl-up]');
      if (u) { upStep(+u.getAttribute('data-cl-up')); return; }
      var g = t.closest('#ClCartDrawer [data-cl-gift-add]');
      if (g) {
        var s = D.querySelector('[data-cl-gift-var]'), err = D.querySelector('[data-cl-gift-err]');
        if (!s || !s.value) { if (err) err.hidden = false; return; }
        if (err) err.hidden = true;
        g.disabled = true;
        add(JSON.stringify({ items: [{ id: +s.value, quantity: 1 }] }))
          .then(refresh).catch(function (er) { alert((er && (er.description || er.message)) || 'Error'); })
          .then(function () { g.disabled = false; });
      }
    }, true);
    D.addEventListener('change', function (e) {
      if (e.target.matches('[data-cl-gift-var]')) { var err = D.querySelector('[data-cl-gift-err]'); if (err) err.hidden = true; }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.getAttribute || (f.getAttribute('action') || '').indexOf('/cart/add') < 0 || e.defaultPrevented) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var btn = e.submitter; if (btn) btn.setAttribute('aria-busy', 'true');
      add(new FormData(f), true).then(function () { return refresh(); }).then(open)
        .catch(function (err) { alert((err && (err.description || err.message)) || 'Error'); })
        .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
    }, true);
    document.addEventListener('cl:cart:added', function () { refresh().then(open, open); });
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
